import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { CircleAlert, CircleCheck } from "lucide-react";

export const StatuteConfirmedIcon = ({
  confirmed,
}: {
  confirmed?: boolean | null;
}) => {
  return confirmed ? (
    <TooltipWrapper message="Statute of limitations confirmed">
      <div>
        <CircleCheck className="h-4 w-4 text-green-500" />
      </div>
    </TooltipWrapper>
  ) : (
    <TooltipWrapper message="Statute of limitations not confirmed">
      <div>
        <CircleAlert className="h-4 w-4 text-yellow-500" />
      </div>
    </TooltipWrapper>
  );
};
